import React from 'react'
import { DisplayIconProps } from '../DisplayIcon.d'

const ThirdPartyIntegrations = ({
  classes,
  inverse,
  color
}: DisplayIconProps) => {
  let strokeFill = color ? color : '#5069C3'
  let accentColor = color ? color : '#FF4C00'
  if (inverse) {
    strokeFill = '#7A7A7A'
    accentColor = '#FFF'
  }

  return (
    <svg
      className={classes}
      data-testid='DisplayIcon-ThirdPartyIntegrations'
      fill='none'
      height='64'
      viewBox='0 0 64 64'
      width='64'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M40.9363 24.7028V22.7689C40.8733 21.444 40.3023 20.1944 39.3419 19.2796C38.3815 18.3648 37.1056 17.8552 35.7792 17.8567H10.8832C9.5568 17.8552 8.28086 18.3648 7.32046 19.2796C6.36005 20.1944 5.78902 21.444 5.72602 22.7689L3.9597 47.8712C3.88336 48.5945 3.95858 49.3257 4.18056 50.0183C4.40255 50.7109 4.76642 51.3497 5.24899 51.8938C5.73829 52.4343 6.32986 52.8725 6.98952 53.1831C7.6552 53.4823 8.37427 53.6445 9.10394 53.6601H24.9363M30.9702 24.4965V9.73424C30.9702 8.70991 30.7684 7.69561 30.3764 6.74925C29.9844 5.80289 29.4099 4.94301 28.6856 4.2187C27.9613 3.49438 27.1014 2.91983 26.155 2.52783C25.2086 2.13584 24.1943 1.93408 23.17 1.93408C22.1457 1.93408 21.1314 2.13584 20.185 2.52783C19.2387 2.91983 18.3788 3.49438 17.6545 4.2187C16.9302 4.94301 16.3556 5.80289 15.9636 6.74925C15.5716 7.69561 15.3699 8.70991 15.3699 9.73424V24.4965H30.9702Z'
        data-testid='DisplayIcon-ThirdPartyIntegrations-strokeFill'
        stroke={strokeFill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M31.7824 38.2532L26.2901 39.2073L31.7824 38.2532ZM18.3481 36.964C18.9875 36.3308 19.7994 35.9001 20.6823 35.7258C21.5651 35.5515 22.4798 35.6414 23.3119 35.9841C24.1454 36.3298 24.8578 36.9148 25.359 37.6652C25.8602 38.4156 26.1277 39.2977 26.1277 40.2001C26.1277 41.1024 25.8602 41.9846 25.359 42.735C24.8578 43.4854 24.1454 44.0704 23.3119 44.416C22.4798 44.7588 21.5651 44.8486 20.6823 44.6743C19.7994 44.5 18.9875 44.0694 18.3481 43.4362C17.4978 42.5789 17.0207 41.4204 17.0207 40.213C17.0207 39.0055 17.4978 37.847 18.3481 36.9898V36.964Z'
        data-testid='DisplayIcon-ThirdPartyIntegrations-accentColor'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M32.7881 54.2661C33.2667 53.7905 33.8446 53.4266 34.4803 53.2004C35.1161 52.9743 35.794 52.8916 36.4655 52.9581C37.1369 53.0246 37.7854 53.2388 38.3644 53.5853C38.9434 53.9318 39.4387 54.402 39.8147 54.9623C40.3104 55.7142 40.5746 56.5951 40.5746 57.4957C40.5746 58.3964 40.3104 59.2772 39.8147 60.0292C39.3122 60.7814 38.5991 61.3688 37.7647 61.7181C36.9492 62.0558 36.0523 62.1455 35.1861 61.976C34.3709 61.8159 33.6147 61.437 32.9984 60.8799C32.3822 60.3227 31.9292 59.6083 31.688 58.8134C31.4469 58.0184 31.4267 57.1727 31.6295 56.3671C31.8324 55.5615 32.2507 54.8263 32.8396 54.2403L32.7881 54.2661Z'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M53.3393 29.2668C53.983 28.6527 54.7917 28.2395 55.6665 28.0778C56.5413 27.916 57.4443 28.0127 58.2651 28.356C59.0858 28.6994 59.7886 29.2745 60.2877 30.0109C60.7867 30.7474 61.0603 31.6134 61.075 32.5029C61.0719 33.1771 60.9203 33.8423 60.6311 34.4512C60.3418 35.0602 59.9219 35.5979 59.4013 36.0263C58.8806 36.4546 58.272 36.763 57.6187 36.9295C56.9654 37.0959 56.2835 37.1165 55.6214 36.9896C54.7311 36.8054 53.9175 36.3559 53.2878 35.7003C52.4436 34.8398 51.9708 33.6825 51.9708 32.4771C51.9708 31.2717 52.4436 30.1144 53.2878 29.2539L53.3393 29.2668Z'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M52.0114 33.9729L46.2225 35.3395'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M39.0024 44.9059C40.4335 44.9085 41.8332 44.4864 43.0243 43.6932C44.2154 42.9 45.1445 41.7713 45.6939 40.4499C46.2433 39.1285 46.3884 37.6738 46.1108 36.2699C45.8332 34.866 45.1453 33.576 44.1343 32.5632C43.1233 31.5504 41.8345 30.8602 40.4311 30.5801C39.0277 30.3 37.5728 30.4425 36.2504 30.9895C34.928 31.5366 33.7976 32.4636 33.0023 33.6533C32.207 34.8431 31.7825 36.242 31.7825 37.6731C31.7808 38.6223 31.9663 39.5625 32.3283 40.44C32.6904 41.3174 33.222 42.1149 33.8926 42.7867C34.5632 43.4585 35.3597 43.9915 36.2365 44.3551C37.1133 44.7188 38.0532 44.9059 39.0024 44.9059V44.9059Z'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M36.9525 51.4556L37.9581 44.906'
        stroke={accentColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
    </svg>
  )
}

export default ThirdPartyIntegrations
